<template>
  <main class="page">
    <h1>Страница не найдена</h1>
  </main>
</template>

<script>

export default {
  name: 'PageNotFound',
  metaInfo () {
    return this.$seo('common', '', '', '', '', '', '')
  }
}
</script>
